import React from 'react';
import { NavLink } from 'react-router-dom';
import { useDeviceRequestBadges, CountBadge } from '../DeviceRequests/deviceRequestApi';
import { useDispatch } from 'react-redux';
import { logout } from '../../actions/authActions';
import { SidebarLogo, SidebarNavList } from '../common/SidebarNav';
import '../HR/hrSidebar.css';

export const EC_DASHBOARD = { to: '/enrollment/patients', icon: 'fas fa-user-injured', label: 'Patients' };

// Enrollment Coordinator navigation: patient basics, device inventory, assign/unassign only.
const EnrollmentSidebar = () => {
    const dispatch = useDispatch();
    const drBadges = useDeviceRequestBadges();
    const icon = { color: '#FEFFFF', fontSize: '24px' };

    return (
        <div className="sidebar hr-white-sidebar">
            <SidebarLogo />
            <SidebarNavList dashboard={EC_DASHBOARD}>
                <li className="nav_link">
                    <NavLink key="enrollDeviceRequests" to="/enrollment/device-requests" activeClassName="link-name-active">
                        <i className="fas fa-clipboard-list" style={icon}></i>
                        <span className="link_name" title="Device Requests — Pending">Device Requests — Pending<CountBadge n={drBadges.ecPending} title="Pending device requests" /></span>
                    </NavLink>
                </li>
                <li className="nav_link">
                    <NavLink key="enrollDevices" to="/enrollment/devices" activeClassName="link-name-active">
                        <i className="fas fa-weight" style={icon}></i>
                        <span className="link_name" title="Device Inventory">Device Inventory</span>
                    </NavLink>
                </li>
                <li className="nav_link">
                    <NavLink key="enrollAssign" to="/devices/assign" activeClassName="link-name-active">
                        <i className="fas fa-barcode" style={icon}></i>
                        <span className="link_name" title="Assign / Unassign">Assign / Unassign</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink key="logout" to="#" onClick={() => dispatch(logout())} style={{ backgroundColor: 'red' }}>
                        <i className="bx bx-log-out"></i>
                        <span className="link_name" style={{ color: '#FFF' }}>Logout</span>
                    </NavLink>
                </li>
            </SidebarNavList>
        </div>
    );
};

export default EnrollmentSidebar;
